import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import { pencesToPounds } from '../common/helpers/pencesToPounds';
import { getFeesSettings } from '../register/RegisterActions';

function FeesInformationPage() {
  const feesSettings = useSelector((state) => state.register.get('feesSettings'));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFeesSettings());
  }, [dispatch]);

  const sellersFee = useMemo(
    () =>
      feesSettings.saleBetween1001And5000InPence ===
        feesSettings.saleBetween5001And10000InPence &&
      feesSettings.saleBetween5001And10000InPence ===
        feesSettings.saleBetween10001And15000InPence &&
      feesSettings.saleBetween10001And15000InPence ===
        feesSettings.saleForLessThan1000InPence &&
      feesSettings.saleForLessThan1000InPence === feesSettings.saleForMoreThan15000InPence
        ? feesSettings.saleBetween5001And10000InPence
        : 4500,
    [feesSettings],
  );

  return (
    <div className="custom-site__outer-wrapper">
      <div className="custom-site__inner-wrapper">
        <Col className="register-form-container d-flex flex-column justify-content-center align-items-center">
          <div className="register-form-container__title w-100 w-100 mb-4">
            <Col md={12} className="w-100">
              <h1
                className="cutom-site__title"
                style={{
                  paddingBottom: '16px',
                  fontSize: '32px',
                  width: '100%',
                  borderBottom: '2px solid #F1001E',
                }}
              >
                Fee Information
              </h1>
            </Col>
          </div>
          <Row className="register-form-container__content w-100 mb-5">
            <div className="fees__payment-details">
              <Row className="payment-details__table">
                <Col md="6" className="mt-2">
                  <p className="fees-table-title">
                    <strong>Buyers Fees:</strong>
                  </p>
                  <div className="fees-table-container">
                    <p className="fees-table-description">
                      See below buyers fees that apply to each vehicle purchase:
                    </p>
                    <table className="price-table--custom">
                      <tbody>
                        <tr>
                          <td>
                            <p className="price__cell-text">£0 - £1,000</p>
                          </td>
                          <td>
                            <p className="price__cell-text--right">
                              <strong>
                                £{pencesToPounds(feesSettings.purchaseForLessThan1000InPence)}{' '}
                                + VAT
                              </strong>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p className="price__cell-text">£1,001 - £5,000</p>
                          </td>
                          <td>
                            <p className="price__cell-text--right">
                              <strong>
                                £
                                {pencesToPounds(
                                  feesSettings.purchaseBetween1001And5000InPence,
                                )}{' '}
                                + VAT
                              </strong>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p className="price__cell-text">£5,001 - £10,000</p>
                          </td>
                          <td>
                            <p className="price__cell-text--right">
                              <strong>
                                £
                                {pencesToPounds(
                                  feesSettings.purchaseBetween5001And10000InPence,
                                )}{' '}
                                + VAT
                              </strong>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p className="price__cell-text">£10,001 - £15,000</p>
                          </td>
                          <td>
                            <p className="price__cell-text--right">
                              <strong>
                                £
                                {pencesToPounds(
                                  feesSettings.purchaseBetween10001And15000InPence,
                                )}{' '}
                                + VAT
                              </strong>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p
                              className="price__cell-text pl-0 ml-0"
                              style={{ margin: 0, padding: 0 }}
                            >
                              £15,001+
                            </p>
                          </td>
                          <td>
                            <p className="price__cell-text--right">
                              <strong>
                                £{pencesToPounds(feesSettings.purchaseForMoreThan15000InPence)}{' '}
                                + VAT
                              </strong>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Col>
                <Col md="6" className="mt-sm-4 mt-md-2 mt-lg-2 d-flex flex-column">
                  <p className="fees-table-title">
                    <strong>Sellers Fees:</strong>
                  </p>
                  <div className="sellers-container">
                    <p className="sellers-description">
                      The Stock Vault set out to make selling your vehicles quick and easy.
                      That&apos;s why we&apos;ve built a streamlined platform, ready to use.
                    </p>
                    <p className="sellers-fee-text">
                      {`Sellers pay a one-off £${pencesToPounds(sellersFee)} per listing fee.`}{' '}
                      <br /> No hidden costs.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </Row>
        </Col>
      </div>
    </div>
  );
}

export default FeesInformationPage;
